import { createAction } from "~/utils/actions";

export default {
	...createAction("LOGOUT"),
	...createAction("TOGGLE_USER_MENU"),
	...createAction("CAN_GO_BACK"),
	...createAction("SET_RETURN_URL"),
};
